import { render, staticRenderFns } from "./BaseSmall.vue?vue&type=template&id=489c4e47&lang=pug&"
import script from "./BaseSmall.vue?vue&type=script&lang=js&"
export * from "./BaseSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports